import React from "react";
import { TBFL1BackendRecord } from "../../../../redux/app/bfl-1/@types";
import BFL1TableRows from "./BFL1TableRows";
import getSignTableRows from "./getSignTableRows";
type OwnProps = {
	bfl1Record: TBFL1BackendRecord;
};
type BFL1RecordParticipantsViewProps = OwnProps;
function BFL1RecordParticipantsView(props: BFL1RecordParticipantsViewProps) {
	const { bfl1Record } = props;

	return (
		<BFL1TableRows
			record={bfl1Record}
			tableRows={getSignTableRows(bfl1Record)}
		/>
	);
}

export default BFL1RecordParticipantsView;
